const getItemsArray = (items) => {
    if (!items) return []
    if (Array.isArray(items)) return items
    if (typeof items === 'object') return Object.keys(items).map((key) => items[key])

    return []
}

const getItemIds = (item) => {
    return [
        item?._id,
        item?.productId,
        item?.cartItemId,
        item?.product?._id,
        item?.product,
        item?.img
    ]
        .filter((value) => value !== undefined && value !== null)
        .map((value) => String(value))
}

const activeAddButton = (productId, items, type) => {
    const targetId = String(productId || '')
    const itemsProd = getItemsArray(items)

    if (!targetId) return undefined

    if (type === 'img') {
        const foundByImage = itemsProd.find((item) => String(item?.img || '') === targetId)

        return foundByImage?.img
    }

    const found = itemsProd.find((item) => {
        return getItemIds(item).includes(targetId)
    })

    if (!found) return undefined

    const ids = getItemIds(found)

    return ids.includes(targetId) ? targetId : undefined
}

export default activeAddButton